"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _uiImages = require("ui-images");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _UIImage = _interopRequireDefault(require("./UIImage"));

var _BrowserTest = require("../utils/BrowserTest");

var validateDimensions = function validateDimensions(_ref) {
  var height = _ref.height,
      width = _ref.width;

  if (height == null && width == null) {
    _devLogger.default.warn({
      message: 'UIAbstractIllustration: Provide either width or height prop to ensure proper scaling.',
      key: 'UIAbstractIllustration-dimensions-none'
    });

    return;
  }

  if (height != null && width != null) {
    _devLogger.default.warn({
      message: 'UIAbstractIllustration: Setting both width and height may not behave as expected.',
      key: 'UIAbstractIllustration-dimensions-both'
    });
  }
};

var getClassNames = function getClassNames(className, disabled) {
  return (0, _classNames.default)(className, 'private-illustration', {
    'private-illustration--disabled': disabled
  });
};

var _default = _react.default.createClass({
  displayName: "UIAbstractIllustration",
  propTypes: (0, _extends2.default)({}, (0, _omit.default)(_UIImage.default.propTypes, 'src', 'responsive'), {
    disabled: _react.PropTypes.bool,
    height: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    name: _react.PropTypes.string,
    width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    _getImageUrlFromName: _react.PropTypes.func.isRequired
  }),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, (0, _omit.default)(_UIImage.default.defaultProps, 'responsive'), {
      _getImageUrlFromName: function _getImageUrlFromName(name) {
        return (0, _uiImages.getImageUrl)(name, undefined, (0, _BrowserTest.isIE11)());
      }
    });
  },
  componentWillMount: function componentWillMount() {
    validateDimensions(this.props);
  },
  componentWillUpdate: function componentWillUpdate(nextProps) {
    validateDimensions(nextProps);
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        disabled = _this$props.disabled,
        name = _this$props.name,
        _getImageUrlFromName = _this$props._getImageUrlFromName,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "disabled", "name", "_getImageUrlFromName"]);
    return _react.default.createElement(_UIImage.default, (0, _extends2.default)({}, rest, {
      responsive: false,
      className: getClassNames(className, disabled),
      objectFit: "contain",
      src: _getImageUrlFromName(name)
    }));
  }
});

exports.default = _default;
module.exports = exports.default;